import React from "react";
import '../../styles/desktop/loader.css';

const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;